module.exports = __webpack_public_path__ + "img/musical-key.24feab4f.jpeg";